"use client";
import React from "react";
import CustomLink from "./custom-link";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import JSXStyle from "styled-jsx/style";

function NextPrev({ bookSlug, prevChapterSlug, nextChapterSlug, backgroundColor, hoverBgColor }: { bookSlug: string; prevChapterSlug: string; nextChapterSlug: string; backgroundColor: string; hoverBgColor: string }) {
    return (
        <div className="flex justify-between items-center font-semibold">
            {prevChapterSlug ? (
                <CustomLink href={`/truyen/${bookSlug}/${prevChapterSlug}`} className={`flex items-center gap-x-2 pt-2 pb-2 pr-4 pl-4 rounded-lg hover:bg-${hoverBgColor}`} style={{ background: backgroundColor }}>
                    <BsArrowLeft />
                    Chương trước
                </CustomLink>
            ) : (
                <div></div>
            )}
            {nextChapterSlug && (
                <CustomLink href={`/truyen/${bookSlug}/${nextChapterSlug}`} className={`flex items-center gap-x-2 pt-2 pb-2 pr-4 pl-4 rounded-lg hover:bg-${hoverBgColor}`} style={{ background: backgroundColor }}>
                    Chương sau <BsArrowRight />
                </CustomLink>
            )}
        </div>
    );
}

export default NextPrev;
